/* Millimili ‚Äî assets/wt-defer-media.js  (perf 2026-09-17 v1, swatch duzeltmesi 2026-09-20 v2)
 *
 * NEDEN (17 Eyl hiz testi, telefon 4G 10 Mbps + CPU 4x, kablo bayti):
 *   Urun sayfasi: ana gorsel (143 KB, fetchpriority=high) 2,3-2,9 sn'de iniyordu,
 *   cunku yaninda ekranin sagindaki 16 galeri gorseli (~2,4 MB) ayni anda iniyordu.
 *   loading="lazy" yatay kaydiricida ise yaramiyor: Chrome ~1250px mesafedekileri
 *   hemen yukler. LCP 3,4 sn ‚Äî Babyboo 1,1 sn.
 *   Koleksiyon: kart basina 5 gorsellik galeri, 36 kart = 180 gorsel ilk anda
 *   (9,95 MB); ilk kart gorseli 5 sn'de.
 *
 * YAKLASIM: Liquid, ekranda olmayan galeri gorsellerini src/srcset yerine
 *   data-wt-src / data-wt-srcset ile basar (src = 1x1 seffaf gif, width/height
 *   korunur -> yerlesim kaymaz). Bu dosya onlari dogru anda geri baglar.
 *
 *   data-wt-defer="pdp"  : masaustunde (>=900px, 2 slayt yan yana) hemen.
 *                          Telefonda ana gorsel yuklenince +300 ms, ya da ilk
 *                          dokunma/tus/tekerlek, en gec 5 sn.
 *   data-wt-defer="card" : karta dokunulunca / fare ustune gelince / odaklaninca
 *                          o kartin tum slaytlari. Kart ekrana yaklasinca
 *                          (sayfa yuklendikten sonra) yalnizca siradaki slayt
 *                          hazir tutulur ki kaydirmada bos kare gorulmesin.
 */
(() => {
  if (window.__wtDeferMedia) return;
  window.__wtDeferMedia = true;

  function restore(el) {
    if (el.tagName === 'VIDEO') {
      const p = el.getAttribute('data-wt-poster');
      if (p) { el.setAttribute('poster', p); el.removeAttribute('data-wt-poster'); }
      el.removeAttribute('data-wt-defer');
      return;
    }
    const ss = el.getAttribute('data-wt-srcset');
    if (ss !== null) { el.setAttribute('srcset', ss); el.removeAttribute('data-wt-srcset'); }
    const s = el.getAttribute('data-wt-src');
    if (s !== null) { el.setAttribute('src', s); el.removeAttribute('data-wt-src'); }
    el.removeAttribute('data-wt-defer');
  }

  const all = (root, kind) => (root || document).querySelectorAll(`[data-wt-defer="${kind}"]`);

  /* ---------------- urun sayfasi ---------------- */
  (function pdp() {
    if (!all(document, 'pdp').length) return;
    let done = false;

    /* GORUNURLUGE YAKIN OLANI YUKLE.
     *
     * Eskiden butun pdp gorselleri bir kerede geri baglaniyordu. Renk
     * secilince galeri slaytlari yeniden cizildigi icin (gallery.js
     * filterSlides) tek tiklamada onlarca fotograf + kucuk resim ayni anda
     * indirilmeye basliyordu: olcum 2026-09-20, ma-0068 -> tiklama 211 ms
     * ana is parcacigini bloklad ve sonraki tiklama bir sure cevap vermedi.
     * Artik yalnizca gorunume yaklasan gorsel yuklenir, kalani kaydirinca
     * gelir; aktif slayt zaten gorunumde oldugu icin aninda gelir. */
    const pdpIo = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          for (const e of entries) {
            if (!e.isIntersecting) continue;
            pdpIo.unobserve(e.target);
            restore(e.target);
          }
        }, { rootMargin: '400px' })
      : null;
    const watch = (root) => {
      const els = all(root, 'pdp');
      if (!els.length) return;
      if (!pdpIo) { els.forEach(restore); return; }
      els.forEach((el) => pdpIo.observe(el));
    };
    const go = () => {
      if (done) return;
      done = true;
      watch(document);
    };

    /* Renk degisince galeri slaytlari ACILISTAKI kopyadan yeniden cizilir
     * (gallery.js filterSlides). O kopya ertelenmis kalirsa gorseller bos
     * gorunuyordu (2026-09-19). Sonradan eklenen slaytlar da izleyiciye
     * baglanir; yukleme yine gorunurluge gore olur. */
    if ('MutationObserver' in window) {
      new MutationObserver((muts) => {
        if (!done) return;
        for (const m of muts) {
          for (const n of m.addedNodes) {
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('[data-wt-defer="pdp"]')) {
              if (pdpIo) pdpIo.observe(n); else restore(n);
            }
            if (n.querySelectorAll) watch(n);
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }

    if (window.matchMedia('(min-width: 900px)').matches) { go(); return; }

    const later = () => setTimeout(go, 300);
    const hero = document.querySelector('.wt-product__img[fetchpriority="high"]');
    if (!hero || (hero.complete && hero.naturalWidth > 1)) later();
    else {
      hero.addEventListener('load', later, { once: true });
      hero.addEventListener('error', later, { once: true });
    }
    ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach((t) =>
      document.addEventListener(t, go, { once: true, passive: true, capture: true }));
    setTimeout(go, 5000);
  })();

  /* ---------------- koleksiyon kartlari ---------------- */
  const cardOf = (t) => t && t.closest && t.closest('card-gallery, .card-pro__gallery, .card__container');
  const wake = (e) => {
    const c = cardOf(e.target);
    if (c) all(c, 'card').forEach(restore);
  };
  ['pointerover', 'touchstart', 'focusin'].forEach((t) =>
    document.addEventListener(t, wake, { passive: true, capture: true }));

  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (!e.isIntersecting) continue;
          const next = all(e.target, 'card')[0];
          if (next) restore(next);
          io.unobserve(e.target);
        }
      }, { rootMargin: '200px 0px' })
    : null;

  const watch = (root) => {
    (root || document).querySelectorAll('card-gallery, .card-pro__gallery').forEach((g) => {
      if (!all(g, 'card').length) return;
      if (io) io.observe(g); else all(g, 'card').forEach(restore);
    });
  };

  const start = () => {
    watch(document);
    // "Daha fazla yukle" / filtre ile gelen kartlar
    if ('MutationObserver' in window) {
      new MutationObserver((muts) => {
        for (const m of muts) for (const n of m.addedNodes) {
          if (n.nodeType === 1 && n.querySelector && n.querySelector('[data-wt-defer="card"]')) watch(n.parentElement || n);
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  };
  // Siradaki slayti hazirlamak ilk ekrani yavaslatmasin: sayfa yuklendikten sonra.
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();
